module.exports = __webpack_public_path__ + "static/media/color-picker.be2c939c.svg";